import { useUpdate } from 'react-admin';
import { ScmTag } from '../types';
import { TagDialog } from './TagDialog';

type TagEditModalProps = {
    tag: ScmTag;
    open: boolean;
    onClose(): void;
    onSuccess?(tag: ScmTag): Promise<void>;
};

export function TagEditModal({
    tag,
    open,
    onClose,
    onSuccess,
}: TagEditModalProps) {
    const [update] = useUpdate<ScmTag>();

    const handleEditTag = async (data: Pick<ScmTag, 'descricao_tag' | 'color' | 'visibilidade'>) => {
        await update(
            'scmtags',
            { id: tag.id, data, previousData: tag },
            {
                onSuccess: async tag => {
                    await onSuccess?.(tag);
                },
            }
        );
    };

    return (
        <TagDialog
            open={open}
            title="Editar tag"
            onClose={onClose}
            onSubmit={handleEditTag}
            tag={tag}
        />
    );
}
